import { DocumentAdditionalInfo } from '../services/web/types/requestWebServiceTypes'

export const trimEmplyFileInfo = (documentAdditionalInfo?: DocumentAdditionalInfo[]) => {
    if (!documentAdditionalInfo) return []

    return documentAdditionalInfo.filter((e) => !!e.fileInfo && Array.isArray(e.fileInfo) && e.fileInfo.length > 0)
}

export const withFileTokenInfo = (documentAdditionalInfo?: DocumentAdditionalInfo[]) => {
    if (!documentAdditionalInfo) return []

    return documentAdditionalInfo.map((e) => ({
        ...e,
        fileTokenInfo: e.fileInfo,
    }))
}

function isPdfFile(filename: string): boolean {
    return /\.pdf$/i.test(filename.trim())
}

export const checkAllAdditionalDocTopicsHavePdf = (documentAdditionalInfo?: DocumentAdditionalInfo[]) => {
    if (!documentAdditionalInfo) return true

    return documentAdditionalInfo.every((e) => {
        const files = e.fileInfo ?? []
        return files.length === 0 || files.some((f) => isPdfFile(f.filename ?? ''))
    })
}
